import React from 'react';
import clsx from 'clsx';

import styles from '../styles.module.scss';
import localStyles from './Local.module.scss';
import {Localisation} from '../../../assets';

export const LocalisationCard = () => {
  return (
    <div className={localStyles.local}>
      <div className={clsx(styles.label, styles.web)}>
        <div className={clsx(styles.labelInner, styles.web)}>web</div>
      </div>
      <h4 className={styles.title}>Localisation</h4>
      <p className={styles.subTitle}>
        Butler is a sophisticated AI assistant tailored to each project individually, providin.
      </p>
      <div className={localStyles.infoWrapper}>
        <Localisation />
      </div>
    </div>
  );
};
